import React from 'react'

class NextWeekButton extends React.Component {

    render() {
        return <button onClick={() => this.props.skipDays(7) }>Next Week &gt;&gt;</button>
    }
}

export default NextWeekButton